import { z } from 'zod';
import { UserRole, ParentRole, College, StudentGender } from './enums';
import { NotificationTypes } from '../notifications';

export const UserDataForClientSchema = z.object({
    id: z.string(),
    email: z.string().email().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    userRole: z.nativeEnum(UserRole),
    parentRole: z.nativeEnum(ParentRole).optional(),
    college: z.nativeEnum(College).optional(),
    stateOfResidence: z.string().optional(),
    numberOfChildren: z.number().int().positive().optional(),
    studentGender: z.nativeEnum(StudentGender).optional(),
    studentAge: z.number().int().positive().optional(),
    studentFirstName: z.string().optional(),
    studentPhoneLastFour: z
        .string()
        .length(4)
        .regex(/^\d{4}$/)
        .optional(),
    avatarUrl: z.string().optional(),
    onboardingCompleted: z.boolean().default(false),
    notificationPermissions: z
        .record(z.nativeEnum(NotificationTypes), z.boolean())
        .default({
            [NotificationTypes.reminders]: true,
            [NotificationTypes.updates]: true,
        }),
    // Admin-only fields for user management
    completedQuizzesCount: z.number().int().nonnegative().optional(),
    totalArticleReads: z.number().int().nonnegative().optional(),
    uniqueArticlesRead: z.number().int().nonnegative().optional(),
});
